import { CapitalizeFirstPipe } from '$shared/pipes/capitalize-first.pipe';
import { NewDatePipe } from '$shared/pipes/new-date.pipe';
import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { BatchDocumentToastComponent } from './services';
import { InlineSVGModule } from 'ng-inline-svg-2';
import {
  AUTH_SERVICE,
  PROTECTED_FALLBACK_PAGE_URI,
  ProtectedGuard,
  PUBLIC_FALLBACK_PAGE_URI,
  PublicGuard,
} from './auth';
import { defineLocale, ruLocale } from 'ngx-bootstrap/chronos';
import {
  BsDatepickerConfig,
  BsDatepickerModule,
  BsLocaleService,
} from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipConfig, TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { provideNgxMask } from 'ngx-mask';
import { ApiPrefixInterceptor } from './interceptors/api-prefix.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { HeaderInterceptor } from './interceptors/headers.interceptor';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { ModalModule } from './modal/modal.module';
import { defaultControlErrors } from './models/errors';
import { AuthenticationService } from './services/auth.service';
import { ErrorsHandlerService } from './services/errors-handler.service';
import { ShellModule } from './shell/shell.module';
import { ErrorHandlerInterceptor } from '$core/interceptors/error-handler.interceptor';
import { UserAgreementInterceptor } from '$core/interceptors/user-agreement.interceptor';
import { CONTROL_ERRORS } from './tokens/control-errors.token';

defineLocale('ru', ruLocale);

export const customBsTooltipConfig = {
  container: 'body',
};

export const customBsDatepickerConfig = {
  containerClass: 'theme-dark-blue',
  showWeekNumbers: false,
  selectFromOtherMonth: true,
};

export const swalConfig = {
  title: 'DONE',
  text: '',
  type: 'success',
  buttonsStyling: false,
  confirmButtonText: 'ОК',
  confirmButtonClass: 'button button--filled',
  showCancelButton: false,
  cancelButtonText: 'Отмена', // TODO: translate
  cancelButtonClass: 'button button--outlined',
  imageUrl: null,
  html: null,
  imageWidth: null,
  imageHeight: null,
  width: null,
};

@NgModule({
  imports: [
    CommonModule,
    ShellModule,
    ModalModule,
    LoggerModule.forRoot({ level: NgxLoggerLevel.DEBUG }),
    BsDatepickerModule.forRoot(),
    TabsModule.forRoot(),
    TypeaheadModule.forRoot(),
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    NgxIntlTelInputModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      positionClass: 'toast-bottom-center',
      timeOut: 7000,
      progressBar: false,
      closeButton: true,
      enableHtml: true,
    }),
    BatchDocumentToastComponent,
    InlineSVGModule.forRoot(),
  ],
  exports: [ShellModule],
  providers: [
    provideNgxMask(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiPrefixInterceptor,
      multi: true,
    },
    /*    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiLogInterceptor,
      multi: true,
    },*/
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserAgreementInterceptor,
      multi: true,
    },
    { provide: CONTROL_ERRORS, useValue: defaultControlErrors },
    {
      provide: ErrorHandler,
      useClass: ErrorsHandlerService,
    },
    [
      { provide: PROTECTED_FALLBACK_PAGE_URI, useValue: '' },
      { provide: PUBLIC_FALLBACK_PAGE_URI, useValue: '' },
      { provide: AUTH_SERVICE, useClass: AuthenticationService },
    ],
    PublicGuard,
    ProtectedGuard,
    DatePipe,
    NewDatePipe,
    CapitalizeFirstPipe,
  ],
})
export class CoreModule {
  constructor(
    @Optional() @SkipSelf() parentModule: CoreModule,
    private bsLocaleService: BsLocaleService,
    private bsDatepickerConfig: BsDatepickerConfig,
    private bsTooltipConfig: TooltipConfig
  ) {
    if (parentModule) {
      const msg = `CoreModule has already been loaded.
      Import CoreModule once, only, in the root AppModule.`;
      throw new Error(msg);
    }

    this.bsLocaleService.use('ru');
    Object.assign(this.bsDatepickerConfig, customBsDatepickerConfig);
    Object.assign(this.bsTooltipConfig, customBsTooltipConfig);
  }
}
